module.exports = __webpack_public_path__ + "static/media/21ECLAC9.a2b21494.jpg";